<template>
  <span>{{ dots }}</span>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const dots = ref('.')
let interval = null

const props = defineProps({
  speed: {
    type: Number,
    default: 250
  }
})

onMounted(() => {
  interval = setInterval(() => {
    dots.value = dots.value.length === 3 ? '.' : dots.value + '.'
  }, props.speed)
})

onUnmounted(() => {
  clearInterval(interval)
})
</script>
